import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Activity, Menu, X, Phone } from "lucide-react";
import { SITE, NAV_LINKS, telLink } from "../data/siteConfig";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-gray-100 bg-white/95 backdrop-blur-sm">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2.5" data-testid="header-logo">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#1E88E5] text-white">
            <Activity size={22} aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base font-extrabold tracking-tight text-[#0B3056]">
              {SITE.name}
            </span>
            <span className="block text-[11px] font-medium text-slate-500">{SITE.tagline}</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Main navigation">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `rounded-full px-3.5 py-2 text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-[#F0F7FA] text-[#0B3056]" : "text-slate-600 hover:text-[#0B3056]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={telLink}
            data-testid="header-call-button"
            className="hidden items-center gap-2 rounded-full px-3 py-2 text-sm font-semibold text-[#0B3056] transition-colors hover:bg-[#F0F7FA] md:inline-flex"
          >
            <Phone size={17} aria-hidden="true" />
            {SITE.phone}
          </a>
          <a
            href={telLink}
            data-testid="header-call-icon-mobile"
            aria-label={`Call ${SITE.phone}`}
            className="flex h-11 w-11 items-center justify-center rounded-full text-[#0B3056] hover:bg-[#F0F7FA] md:hidden"
          >
            <Phone size={20} aria-hidden="true" />
          </a>
          <Link
            to="/book-a-test"
            data-testid="header-book-test-button"
            className="inline-flex min-h-[44px] items-center rounded-full bg-[#1E88E5] px-4 py-2 text-sm font-semibold text-white shadow-sm transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#1565C0] hover:shadow-lg sm:px-5"
          >
            Book a Test
          </Link>
          <button
            type="button"
            data-testid="header-menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="flex h-11 w-11 items-center justify-center rounded-full text-[#0B3056] hover:bg-[#F0F7FA] lg:hidden"
          >
            {open ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-gray-100 bg-white px-4 py-3 lg:hidden" aria-label="Mobile navigation">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-lg px-4 py-3 text-base font-medium transition-colors ${
                  isActive ? "bg-[#F0F7FA] text-[#0B3056]" : "text-slate-600 hover:bg-[#F0F7FA]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
